import { BaseObjectDto } from "../../../core/business-objects/base-object/base-object.dto";
import { DtoInclude, DtoIncludeNumber } from "../../../core/store/dto/dto";
import { isDefined } from "ionic-angular/util/util";

export class UserDto extends BaseObjectDto {
    username: string;
    @DtoInclude
    name: string;
    @DtoInclude
    email: string;
    @DtoInclude
    mobile: string;
    // @DtoInclude
    // address: string;
    @DtoIncludeNumber
    enabled: number;
    @DtoInclude
    signature: string;
    @DtoInclude
    profileImage: string;

    lastLogin: string;
    memberships: Array<string>;

    password: string;
    passwordConfirm: string;

    passwordHash: string;
    plainPassword: {};

    getRequestBody(): any {

        let body = super.getRequestBody();

        if (isDefined(this.password)) {
            body = {
                ...body,
                plainPassword: {
                    first: this.password,
                    second: this.passwordConfirm
                }
            };
        }

        return body;
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/user/user.dto.ts